import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {default as UsuarioEdit} from '../../components/Usuario/edit'
import {default as UsuarioNew} from '../../components/Usuario/new'
import { sagaGetUsuarioById, sagaSaveUsuario  } from '../../reducers/usuarioReducer/actions'
import {usuarioEditSelector,usuarioRolSelector} from '../../selectors/usuarioSelector'
import {instalacionSelector} from '../../selectors/sessionSelector'
import { usuarioSelector } from '../../selectors/sessionSelector'
import { sagaEliminarUsuario, sagaReactivarUsuario, sagaAgregarListaBlanca, sagaEliminarListaBlanca, sagaAgregarListaNegra, sagaEliminarListaNegra } from '../../reducers/usuarioReducer/actions'

class UsuarioEditContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            usuario: {
                nombre:"",
            },
            preUsuario: {
                nombre:"",
            },
            cargandoUsuario: true,
            error:undefined,
            usuarioCargado: false,
        }
        // busco los datos iniciales
        let id =  props.match.params.idUsuario
        if (id === "0") id = null;
        props.sagaGetUsuarioById(id)
    }

    componentDidUpdate = (prevProps, prevState) => {
        if(this.state.usuarioCargado === false && this.props.usuarioLogueado !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuarioLogueado.idRol !== 1){
                    window.location.hash = '/'
                }
            })
        }
        /*if(prevProps.usuario.id && (prevProps.usuario !== this.state.usuario)){
            this.setState({usuario: prevProps.usuario, cargandoUsuario:false}, ()=>{this.render()})
        }*/
    }

    componentWillReceiveProps(nextProps){
        if (this.state.cargandoUsuario && nextProps.usuario.id!==undefined){
        this.setState({usuario: nextProps.usuario, preUsuario: nextProps.usuario, cargandoUsuario:false}, ()=>{this.render()})
        }
        this.render()
    }
    
    validateEmail(email){
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    valido(){
        let u = this.state.usuario
        let error = { valido: true }
        if (u.email === "" || u.email === null)
            { error.email = "debe definir un email de usuario"; error.valido=false; } 
        else if(!this.validateEmail(u.email))
            { error.email = "debe definir un email valido"; error.valido=false; } 
        
        if (u.nombre === "" || u.nombre === null){ error.nombre = "debe definir un nombre"; error.valido=false; }
        if (u.apellido === "" || u.apellido === null){ error.apellido = "debe definir un apellido"; error.valido=false; }
        if(u.tipoRol === 1)
        {
            if (u.nombreUsuario === "" || u.nombreUsuario === null){ error.nombreUsuario = "debe definir un nombre de usuario"; error.valido=false; } 
            if (u.rol === "" || u.rol === null){ error.rol = "debe definir un rol de usuario"; error.valido=false; } 
        }
        if (error.valido)
            return true
        else
        {
            this.setState({error})
            return false
        }
    }

    setListaBlanca = (newState) => {
        if(newState) {
            this.props.sagaAgregarListaBlanca(this.state.usuario.id);
        } else {
            this.props.sagaEliminarListaBlanca(this.state.usuario.id);
        }
    }

    setListaNegra = async (newState) => {
        if(newState) {
            this.props.sagaAgregarListaNegra(this.state.usuario.id);
        } else {
           this.props.sagaEliminarListaNegra(this.state.usuario.id);
        }
    }

    render() {
        if (this.state.cargandoUsuario) return <div></div>

        if (this.state.usuario.id !== null) {
            return <UsuarioEdit 
                usuario={this.state.usuario}
                error={this.state.error}
                roles={this.props.roles}
                getPreUsuario={() => {
                    this.setState({
                        usuario: this.state.preUsuario
                    })
                }}
                setListasActivo={(newStateListaBlanca, newStateListaNegra, active) => {
                    if(active !== this.state.usuario.activo){
                        if(active) this.props.sagaReactivarUsuario(this.state.usuario.id);
                        else this.props.sagaEliminarUsuario(this.state.usuario.id);
                        this.setState({
                            usuario: {
                                ...this.state.usuario,
                                activo: active
                            }
                        })
                    }
                    if(newStateListaBlanca !== this.state.usuario.cliente.listaBlancaActive){
                        this.setListaBlanca(newStateListaBlanca);
                    }
                    if(newStateListaNegra !== this.state.usuario.cliente.listaNegraActive){
                        this.setListaNegra(newStateListaNegra); 
                    }
                    this.setState({
                        usuario: {
                            ...this.state.usuario,
                            activo: active,
                            cliente: {
                                ...this.state.usuario.cliente,
                                listaNegraActive: newStateListaNegra,
                                listaBlancaActive: newStateListaBlanca
                            }
                        }
                    })
                }}
                setDNI={(x) => {
                    this.setState(
                        {usuario:
                            {...this.state.usuario,
                                cliente: {
                                    ...this.state.usuario.cliente,
                                    dni: x.value
                                }
                            }
                        }
                    )
                }}
                setPorcentajeDescuento={(x) => {
                    this.setState(
                        {usuario:
                            {...this.state.usuario,
                                cliente: {
                                    ...this.state.usuario.cliente,
                                    porcentajeDescuentoFullCatalogo: x.value
                                }
                            }
                        }
                    )
                }}
                handleOnChange={(x,y)=>{
                    console.log(x);
                    this.setState(
                    {usuario:
                        {...this.state.usuario,
                            ...pathValue(x.target.name.split('.').reverse(), x.target.value)  }
                        }
                    )}
                }
                handleOnCancel={()=>{this.props.history.goBack()}}
                handleOnSave={()=>{
                    if (this.valido()){
                    this.setState({cargandoUsuario:false})
                    this.props.sagaSaveUsuario({...this.state.usuario, idInstalacion: this.props.instalacion.id}, this.props.history)
                    }
                }}
                handleOnSave2={() => {
                    if (this.valido()){
                    this.setState({cargandoUsuario:false})
                    this.props.sagaSaveUsuario({...this.state.usuario, idInstalacion: this.props.instalacion.id})
                    }

                }}
            />
        }else{
            return <UsuarioNew 
                usuario={this.state.usuario}
                error={this.state.error}
                roles={this.props.roles}
                handleOnChange={(x,y)=>{
                    console.log(x);
                    this.setState(
                    {usuario:
                        {...this.state.usuario,
                            ...pathValue(x.target.name.split('.').reverse(), x.target.value)  }
                        }
                    )}
                    }
                handleOnCancel={()=>{this.props.history.goBack()}}
                handleOnSave={()=>{
                    if (this.valido()){
                    this.setState({cargandoUsuario:false})
                    this.props.sagaSaveUsuario({...this.state.usuario, idInstalacion: this.props.instalacion.id}, this.props.history)
                    }
                }}
            /> 
        }
    
    }
}

function pathValue(path, value){
    if (path.length === 1){
        return {[path[0]]:value}
    }else{
        let p = path.pop()
        return {[p]:pathValue(path,value)}
    }

}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        sagaGetUsuarioById, 
        sagaSaveUsuario,
        sagaEliminarUsuario,
        sagaReactivarUsuario,
        sagaAgregarListaBlanca,
        sagaEliminarListaBlanca,
        sagaAgregarListaNegra,
        sagaEliminarListaNegra 
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        usuario: usuarioEditSelector(state),
        roles: usuarioRolSelector(state),
        instalacion: instalacionSelector(state),
        usuarioLogueado: usuarioSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UsuarioEditContainer)